// Dependencies
require("section/map");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/map/index.js
 ** module id = 177
 ** module chunks = 0 1
 **/